import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { selectCompanyAlertsById } from '../../store/slice'
import { SENTIMENT_COLOR_BY_ID, SENTIMENT_ICON_BY_ID } from './helper'

export const TypeDescription = ({ rowId }) => {
  const { sentimentId, alertCriteriaName, alertDesc } = useSelector(
    selectCompanyAlertsById(rowId),
  )

  const color = SENTIMENT_COLOR_BY_ID[sentimentId]

  return (
    <Element className="dFlex">
      <Element>
        <Icon
          className={SENTIMENT_ICON_BY_ID[sentimentId]}
          style={{ fontSize: 13, color, marginRight: 3 }}
        />
      </Element>
      <Element>
        <Element style={{ color }}>{alertCriteriaName}</Element>
        <Element>{alertDesc}</Element>
      </Element>
    </Element>
  )
}
